import { FC } from 'react';
import { Range } from 'types';
import { formatNumber } from 'utils/formats';

type Props = {
  range: Range;
};

const RangeRowLine: FC<Props> = ({ range }) => (
  <span>{`${formatNumber(range.from)} - ${formatNumber(range.to)}`}</span>
);

export default RangeRowLine;
